export const Working = (props) => {
    return (
        <div className="working-process-style2-area" id='working'>
            <div className="working-process-style2-bg" style={{ backgroundImage: "url(img/bg1.jpg)" }}></div>
            <div className="auto-container">
                <div className="sec-title text-center">
                    <div className="sub-title">
                        <h5> How we Work? </h5>
                    </div>
                    <h2 className="clr_white">Four Steps to <br /> R.O Repair Service</h2>

                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="working-process-style2 clearfix">

                            <div className="left pull-left">
                                {/* <!--Start Single Working Process Two--> */}
                                <div className="single-working-process-two">

                                    <div className="counting-box clearfix">
                                        <div className="text">
                                            <h4>Step-01</h4>
                                        </div>

                                    </div>
                                    <div className="content">
                                        <h3>BOOK APPOINTMENT</h3>
                                        <p>Expert RO service first carefully listens to specific client’s requirement with an open mind to understand exactly what they need. We never offer one-size-fits-for-all services but customized solutions.</p>
                                    </div>
                                </div>
                                {/* <!--End Single Working Process Two--> */}

                                {/* <!--Start Single Working Process Two--> */}
                                <div className="single-working-process-two bottom">
                                    <div className="counting-box clearfix">
                                        <div className="text">
                                            <h4>Step-02</h4>
                                        </div>

                                    </div>
                                    <div className="content">
                                        <h3>GET A TECHNICIAN</h3>
                                        <p>It is not sure that all people have same problems regarding their purification systems. Hence, we choose the most helpful way that resolves our client’s issue related to RO system repair and services.<br /> &nbsp;</p>
                                    </div>

                                </div>
                                {/* <!--End Single Working Process Two--> */}
                            </div>

                            <div className="right pull-right">
                                {/* <!--Start Single Working Process Two--> */}
                                <div className="single-working-process-two">

                                    <div className="counting-box clearfix">
                                        <div className="text">
                                            <h4>Step-03</h4>
                                        </div>

                                    </div>
                                    <div className="content">
                                        <h3>SERVICE COMPLETED</h3>
                                        <p>Our specialized and experienced team works in collaboration using the advanced technologies to make sure that your RO system work efficiently and provide pure healthy water free from all water bacteria.</p>
                                    </div>

                                </div>
                                {/* <!--End Single Working Process Two-->

                        <!--Start Single Working Process Two--> */}
                                <div className="single-working-process-two bottom">
                                    <div className="counting-box clearfix">
                                        <div className="text">
                                            <h4>Step-04</h4>
                                        </div>

                                    </div>
                                    <div className="content">
                                        <h3>YOUR FEEDBACK</h3>
                                        <p>After delivering you the desired RO services, we take into an account your feedback to ensure that all your requirements get fulfilled with complete satisfaction by calling you back.<br /> &nbsp;</p>
                                    </div>

                                </div>
                                {/* <!--End Single Working Process Two--> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
